import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import EmailPulseDataGrid from '../../email-pulse-data-grid/email-pulse-data-grid.component';
import {
  getOrdersDataGridColumns,
  ordersColumnVisibilityModel,
} from '../orders.config';
import { EmailPulseExportMutationHook } from '../../email-pulse.types';

type OrdersDataGridProps = {
  'data-testid': string;
  queryName: string;
  useExportMutation: EmailPulseExportMutationHook;
};

/**
 * Orders tab data grid component.
 * Wrapper around the generic EmailPulseDataGrid with Orders-specific configuration.
 */
const OrdersDataGrid = ({
  queryName,
  useExportMutation,
  ...rest
}: OrdersDataGridProps) => {
  const { t } = useTranslation();

  const columns = useMemo(() => getOrdersDataGridColumns(t), [t]);

  return (
    <EmailPulseDataGrid
      columns={columns}
      columnVisibilityModel={ordersColumnVisibilityModel}
      exportFileType="ORDERS"
      queryName={queryName}
      useExportMutation={useExportMutation}
      pinnedLeftColumn="title"
      {...rest}
    />
  );
};

export default OrdersDataGrid;
